"use client";

import { useEffect, useState } from "react";
import HeroPlayButton from "./HeroPlayButton";

type Props = {
  hrefs: string[];
  label: string;
  className?: string;
};

const pickRandom = (hrefs: string[]) =>
  hrefs[Math.floor(Math.random() * hrefs.length)];

const HeroRandomGameButton: FC<Props> = ({ hrefs, label, className }) => {
  const [href, setHref] = useState(hrefs[0]);

  useEffect(() => {
    setHref(pickRandom(hrefs));
  }, [hrefs]);

  if (!hrefs.length) {
    return null;
  }

  return (
    <HeroPlayButton
      href={href}
      label={label}
      className={className}
      onClick={() => setHref(pickRandom(hrefs))}
    />
  );
};

export default HeroRandomGameButton;
